module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h1', [_vm._v("Payment History")]), _vm._v(" "), _c('table', {
    staticClass: "el-table",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Ref")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), (_vm.showTax()) ? _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.taxLabel))]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tfoot'), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.date)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(_vm.formatInteger(item.quantity)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ref))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatNumber(item.amount)))]), _vm._v(" "), (_vm.showTax()) ? _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatNumber(item.tax)))]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatNumber(item.total)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger",
        "icon": "fa fa-times-circle"
      }
    })], 1)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba74236"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/insurance/InsuranceStatement.vue
// module id = 1653
// module chunks = 0